// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getData = createAsyncThunk('batch/getData', async params => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/batch/batchList`, {params})
  return {
    params,
    data: response.data.Response.items,
    totalPages: response.data.Response.total_items
  }
})

export const getBatch = createAsyncThunk('batch/getBatch', async id => {
  let response = {}
  if (id > 0) {
    response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/batch/batchEdit/${id}`)
    return response.data.Response
  } else {
    return response
  }
})

export const addBatch = createAsyncThunk('batch/addBatch', async (CreateBatch) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/batch/batchCreate`, {
    Request: {
      CreateBatch
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }
  return CreateBatch
})

export const updateBatch = createAsyncThunk('batch/addBatch', async (UpdateBatch) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_API}Schedule/batch/batchUpdate`, {
    Request: {
      UpdateBatch
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }
  return UpdateBatch
})

export const changeStatus = createAsyncThunk('batch/changeStatus', async (ChangeStatusBatch, { dispatch, getState }) => {
  const response = await axios.patch(`${process.env.REACT_APP_BASE_API}Schedule/batch/batchChangeStatus`, {
    Request: {
      ChangeStatusBatch
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().batches.params))
  return ChangeStatusBatch
})

export const deleteBatch = createAsyncThunk('batch/deleteBatch', async (payload, { dispatch, getState }) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/batch/batchDelete`, {
      Request: {
        DeleteBatch: payload
      }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }
  
  await dispatch(getData(getState().batches.params))
  return payload
})

export const deleteBatchProduct = createAsyncThunk('batch/deleteBatchProduct', async (payload, { dispatch, getState }) => {
  
  let response = {}
  if (parseInt(payload.id) > 0 && parseInt(payload.userId) > 0) {
    response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/batch/batchProductDelete`, {
      Request: {
        DeleteBatchProduct: payload
      }
    })
    if (response.data.Response.Code === 1 && id > 0) {
      toast.success('Event success')
    } else {
      toast.error('Error')
    }
    await dispatch(getData(getState().batches.params))
  }
  return id
})

export const getLotsByProduct = createAsyncThunk('batch/getLotsByProduct', async ({ productId, search }) => {
  
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/batch/batchLotsByProduct`, {
    Request: {
      LotsByProductBatch: {
        productId,
        search
      }
    }
  })
  return response.data.Response.Items
})

export const getStockBatch = createAsyncThunk('batch/batchStock', async ({ productId, warehouseId }) => {
  
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/batch/batchStock`, {
    Request: {
      StockBatch: { productId, warehouseId }
    }
  })
  return response.data.Response.Items
})

export const appCategoriesSlice = createSlice({
  name: 'batches',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedBatch: [],
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getBatch.fulfilled, (state, action) => {
        state.loading = false
        state.selectedBatch = action.payload.item
      })
      .addCase(getBatch.pending, (state) => {
        state.loading = true
      })
  }
})

export default appCategoriesSlice.reducer
